export default __webpack_public_path__ + "static/media/team2.fa2a0e87.png";